import React, { SVGProps } from "react";

const SVGMessageWarningAlert = (props: SVGProps<any>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM11 17V15H13V17H11ZM11 7V13H13V7H11Z"
        fill="#FF9800"
      />
    </svg>
  );
};

export default SVGMessageWarningAlert;
